import React from 'react';
import { wrapFunctionalComponent } from 'utils/framework';
import LazyLoad from 'components/LazyLoad/LazyLoad';
import RatingsAndReviews from 'components/ProductPage/RatingsAndReviews';
import QuestionsAndAnswers from 'components/ProductPage/QuestionsAndAnswers/QuestionsAndAnswers';

const SocialProofSection = ({
    isSmallView,
    currentProduct,
    productDetails,
    currentSku,
    isRatingsEnabled,
    isQandAEnabled,
    isSentimentSelectedFromHighlyRated,
    reviewStatistics,
    initialTotalReviews,
    showProsAndCons,
    showAddDropDownReviewSection,
    betweenQandAAndReviews
}) => {
    const ratingsContent =
        isRatingsEnabled && !isSentimentSelectedFromHighlyRated ? (
            <LazyLoad
                component={RatingsAndReviews}
                isSmallView={isSmallView}
                productId={productDetails?.productId}
                currentProduct={currentProduct}
                reviewStatistics={reviewStatistics}
                initialTotalReviews={initialTotalReviews}
                showProsAndCons={showProsAndCons}
                showAddDropDownReviewSection={showAddDropDownReviewSection}
            />
        ) : isRatingsEnabled ? (
            <RatingsAndReviews
                isSmallView={isSmallView}
                productId={productDetails?.productId}
                currentProduct={currentProduct}
                reviewStatistics={reviewStatistics}
                initialTotalReviews={initialTotalReviews}
                showProsAndCons={showProsAndCons}
                showAddDropDownReviewSection={showAddDropDownReviewSection}
            />
        ) : null;

    return (
        <>
            {isQandAEnabled && (
                <div id='QandA'>
                    <LazyLoad
                        component={QuestionsAndAnswers}
                        productId={productDetails?.productId}
                        skuId={currentSku?.skuId}
                    />
                </div>
            )}
            {betweenQandAAndReviews}
            {ratingsContent && <div id='ratings-reviews-container'>{ratingsContent}</div>}
        </>
    );
};

export default wrapFunctionalComponent(SocialProofSection, 'SocialProofSection');
